import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconKebabHorizontalComponent } from "./med-icon-kebab-horizontal.component";

@NgModule({
  declarations: [
    MedIconKebabHorizontalComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconKebabHorizontalComponent,
  ],
})
export class MedIconKebabHorizontalModule { }
